import {
    Container,
    Paper,
    Typography,
    Box,
    TextField,
    Button,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormControl,
    FormLabel,
    FormHelperText
} from "@mui/material";
import styles from "../../styles/backButton.module.scss";
import btnStyles from '../../styles/buttons.module.scss';
const today = new Date();

const maxDob = new Date(
    today.getFullYear() - 18,
    today.getMonth(),
    today.getDate()
);


const maxDobString = maxDob.toISOString().split("T")[0];
const todayString = new Date().toISOString().split("T")[0];
export default function HMRCChecklistForm({

    data,

    errors,

    handleChange,

    onBack,

    onContinue

}) {


    return (


            <Paper
                elevation={3}
                 sx={{
                    maxWidth: 1200,
                    mx: "auto",
                    mt: 4,
                    mb: 4,
                    px: { xs: 2, md: 4 },
                    py: 3,
                    borderRadius: 2
                }}
            >


                <Typography
                    variant="h4"
                    gutterBottom
                >

                    HMRC Checklist

                </Typography>


                <Typography
                    sx={{ mb: 4,color: "rgba(0,0,0,0.6)", }}
                >

                    Please complete the following information required for HMRC.

                </Typography>



                <Typography
                    variant="h6"
                    sx={{ mb: 2 }}
                >

                    Personal Details

                </Typography>



                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        mb: 4,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}
                >


                    <TextField

                        label="Last Name"

                        name="lastName"

                        value={data.lastName || ""}

                        onChange={handleChange}

                        error={!!errors.lastName}

                        helperText={errors.lastName}

                    />



                    <TextField

                        label="First Name"

                        name="firstName"

                        value={data.firstName || ""}

                        onChange={handleChange}

                        error={!!errors.firstName}

                        helperText={errors.firstName}

                    />



                    <TextField

                        label="Date of Birth"

                        name="dateOfBirth"

                        type={data.dateOfBirth ? "date" : "text"}

                        value={data.dateOfBirth || ""}
                        onFocus={(e) => {
                            e.target.type = "date";
                        }}
                        onBlur={(e) => {
                            if (!e.target.value) {
                                e.target.type = "text";
                            }
                        }}

                        onChange={handleChange}

                        InputLabelProps={{
                            shrink: true
                        }}

                        error={!!errors.dateOfBirth}

                        helperText={errors.dateOfBirth}
                        inputProps={{
                            max: maxDobString,
                            min: "1900-01-01"
                        }}
                    />



                    <TextField

                        label="National Insurance Number (If Known)"

                        name="nationalInsurance"

                        value={data.nationalInsurance || ""}

                        onChange={handleChange}

                        error={!!errors.nationalInsurance}

                        helperText={errors.nationalInsurance}

                    />


                </Box>



                <FormControl
                    sx={{ mb: 4 }}
                    error={!!errors.gender}
                >

                    <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                        Gender

                    </FormLabel>

                    <RadioGroup
                        row
                        name="gender"
                        value={data.gender || ""}
                        onChange={handleChange}
                    >

                        <FormControlLabel
                            value="Male"
                            control={<Radio />}
                            label="Male"
                        />

                        <FormControlLabel
                            value="Female"
                            control={<Radio />}
                            label="Female"
                        />

                        <FormControlLabel
                            value="Other"
                            control={<Radio />}
                            label="Other"
                        />

                        <FormControlLabel
                            value="Prefer not to say"
                            control={<Radio />}
                            label="Prefer not to say"
                        />

                    </RadioGroup>

                    {errors.gender && (
                        <FormHelperText>
                            {errors.gender}
                        </FormHelperText>
                    )}

                </FormControl>




                <Typography
                    variant="h6"
                    sx={{ mb: 2 }}
                >

                    Home Address

                </Typography>



                <Box
                    sx={{
                        display: "grid",
                        gap: 2,
                        mb: 4,
                        gridTemplateColumns: {
                            xs: "1fr",
                            md: "1fr 1fr"
                        }
                    }}
                >


                    <TextField

                        label="Address Line 1"

                        name="addressLine1"

                        value={data.addressLine1 || ""}

                        onChange={handleChange}

                        error={!!errors.addressLine1}

                        helperText={errors.addressLine1}

                    />


                    <TextField

                        label="Address Line 2"

                        name="addressLine2"

                        value={data.addressLine2 || ""}

                        onChange={handleChange}

                    />


                    <TextField

                        label="Town / City"

                        name="townCity"

                        value={data.townCity || ""}

                        onChange={handleChange}

                        error={!!errors.townCity}

                        helperText={errors.townCity}

                    />



                    <TextField

                        label="County"

                        name="county"

                        value={data.county || ""}

                        onChange={handleChange}

                        error={!!errors.county}

                        helperText={errors.county}

                    />



                    <TextField

                        label="Postcode"

                        name="postcode"

                        value={data.postcode || ""}

                        onChange={handleChange}

                        error={!!errors.postcode}

                        helperText={errors.postcode}

                    />


                </Box>




                <Typography
                    variant="h6"
                    sx={{ mb: 2 }}
                >

                    Employment Details

                </Typography>

                <Box
                    sx={{
                        mt: 4,
                        mb: 4
                    }}
                >

                    <FormControl
                        error={!!errors.hmrcTaxStatement}
                    >

                        <FormLabel sx={{color: "rgba(0,0,0,1)"}}>

                            Choose the statement that applies to you

                        </FormLabel>



                        <RadioGroup

                            name="hmrcTaxStatement"

                            value={
                                data.hmrcTaxStatement || ""
                            }

                            onChange={handleChange}

                        >


                            <FormControlLabel

                                value="A"

                                control={<Radio />}

                                label="Statement A"

                            />


                            <Typography
                                variant="body2"
                                sx={{ ml: 4, mb: 2 }}
                            >

                                This is your first job since 6 April and since then you have not received Jobseeker’s Allowance, Employment and Support Allowance or Incapacity Benefit.

                            </Typography>




                            <FormControlLabel

                                value="B"

                                control={<Radio />}

                                label="Statement B"

                            />


                            <Typography
                                variant="body2"
                                sx={{ ml: 4, mb: 2 }}
                            >

                                Since 6 April you have had another job but do not have a P45 and/or have received Jobseeker’s Allowance, Employment and Support Allowance or Incapacity Benefit.

                            </Typography>




                            <FormControlLabel

                                value="C"

                                control={<Radio />}

                                label="Statement C"

                            />


                            <Typography
                                variant="body2"
                                sx={{ ml: 4 }}
                            >

                                You have another job and/or receive a State, Works or Private Pension.

                            </Typography>


                        </RadioGroup>


                    </FormControl>


                </Box>



                <Box

                    sx={{

                        display: "flex",

                        justifyContent: "space-between",

                        mt: 5

                    }}

                >


                    <Button
                        variant="contained"
                        onClick={onBack}
                        className={styles.backSingleBtn}
                        sx={{  mt: "20px", mb: "20px"}}
                    >
                        Back
                    </Button>
                    <Button
                       className={btnStyles.btnDesktop}
                        variant="contained"
                        size="large"
                        sx={{ textTransform: 'none' }}
                        onClick={onContinue}
                    >
                        Continue
                    </Button>


                </Box>


            </Paper>
    );

}